<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/property-setting' }">
        <app-i18n code="entities.propertySetting.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.propertySetting.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.propertySetting.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-property-setting-view-toolbar v-if="record"></app-property-setting-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-image :label="fields.logo.label" :value="presenter(record, 'logo')"></app-view-item-image>

        <app-view-item-text :label="fields.theme.label" :value="presenter(record, 'theme')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PropertySettingViewToolbar from '@modules/property-setting/components/property-setting-view-toolbar.vue';
import { PropertySettingModel } from '@modules/property-setting/property-setting-model';

const { fields } = PropertySettingModel;

export default {
  name: 'app-property-setting-view-page',

  props: ['id'],

  components: {
    [PropertySettingViewToolbar.name]: PropertySettingViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'propertySetting/view/record',
      loading: 'propertySetting/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'propertySetting/view/doFind',
    }),

    presenter(record, fieldName) {
      return PropertySettingModel.presenter(record, fieldName);
    },
  },
};
</script>
